import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { StammdatenState, StammdatenTabData } from "./masterDataTypes";
import { connectedSiteApi } from "../../../app/apislices/connectedSiteApi";

const initialState: StammdatenState = {
  pages: [
    { name: "Umspannwerk" },
    { name: "Schaltfeld" },
    { name: "Spannungsebene" },
    { name: "Wandlerfaktor Strom" },
    { name: "Wandlerfaktor Spannung" },
    { name: "Messgerättyp" },
    { name: "Routertyp" },
    { name: "Wartungsintervall" },
    { name: "Zeitsynchronisationsart" },
    { name: "Angeschlossene Anlage" },
    { name: "Wandlertyp" },
  ],
  page: "Umspannwerk",
};

const masterData = createSlice({
  name: "masterDataSlice",
  initialState,
  reducers: {
    setPages: (state, action: PayloadAction<StammdatenTabData[]>) => {
      state.pages = action.payload;
    },
    setPage: (state, action: PayloadAction<string>) => {
      state.page = action.payload;
    },
  },
});
export const { setPages, setPage } = masterData.actions;

export default masterData.reducer;

connectedSiteApi.enhanceEndpoints({
  endpoints: {
    getConnectedSiteTyp: {
      providesTags: [],
    },
  },
});
